import { render, staticRenderFns } from "./PaymentTypes.vue?vue&type=template&id=58d916f0&scoped=true"
import script from "./PaymentTypes.vue?vue&type=script&lang=js"
export * from "./PaymentTypes.vue?vue&type=script&lang=js"
import style0 from "./PaymentTypes.vue?vue&type=style&index=0&id=58d916f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d916f0",
  null
  
)

export default component.exports